"use client";

import { Translate } from "@/components/Translate";
import { Tag } from "@/components/ui/Tags";
import { useGlobal } from "@/features/global/GlobalContext";
import styles from "./Header.module.css";

export const OutletTag = () => {
	const {
		data: { colorMap },
	} = useGlobal();
	const outletTagColor = colorMap["Red 20 (Loyalty)"];

	return (
		<Tag
			filled
			className={styles.navTag}
			style={
				{
					...(outletTagColor
						? {
								"--tag-color": outletTagColor.color,
								"--tag-foreground": outletTagColor.foreground,
							}
						: {}),
					paddingInline: "var(--spacing-4)",
					paddingBlock: "var(--spacing-2)",
					borderRadius: "var(--spacing-4)",
				} as React.CSSProperties
			}
		>
			<Translate>Member exclusive</Translate>
		</Tag>
	);
};
